import { GraduationCap, Award, Clock, Accessibility, ShieldCheck } from "lucide-react";

const CREDS = [
  { icon: GraduationCap, text: "BDS" },
  { icon: Award, text: "Cosmetic Dental Surgeon" },
  { icon: Clock, text: "9+ years of clinical experience" },
];
const VALUES = ["Ethics", "Empathy", "Excellence", "Hygiene", "Honest communication"];

export const Doctor = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" id="doctor" data-testid="doctor-section">
    <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10 lg:gap-16 items-center">
      <div className="relative max-w-md mx-auto w-full pb-10 sm:pb-0">
        <img src="/images/doctor-brand.jpg" alt="Dr. Vilayath Mahamadi at Smileton Dental" className="w-full aspect-[4/5] object-cover object-center rounded-[2rem] shadow-[0_30px_60px_-30px_rgba(15,76,92,0.5)]" data-testid="doctor-photo" />
        <img src="/images/doctor-chair.jpg" alt="Dr. Vilayath Mahamadi in the treatment room" className="absolute -bottom-2 sm:-bottom-10 -right-2 sm:-right-8 w-36 sm:w-48 aspect-[4/5] object-cover object-top rounded-3xl border-[6px] border-alabaster shadow-lg" data-testid="doctor-photo-secondary" />
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-light mb-3">Meet your dentist</p>
        <h2 className="text-3xl sm:text-4xl font-semibold text-ink">Dr. Vilayath Mahamadi</h2>
        <div className="mt-5 flex flex-wrap gap-2">
          {CREDS.map(({ icon: I, text }) => (
            <span key={text} className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-sm"><I className="h-4 w-4 text-teal" />{text}</span>
          ))}
        </div>
        <p className="mt-6 text-base md:text-lg text-ink-muted leading-relaxed">
          Known across Hyderabad for painless laser dentistry, dental implants and smile makeovers, Dr. Vilayath takes the time to explain every option clearly — and is especially gentle with children and anxious patients.
        </p>
        <blockquote className="mt-8 border-l-4 border-teal pl-5">
          <p className="font-display text-xl sm:text-2xl text-teal leading-snug">"Ethics, empathy, excellence, hygiene, and honest communication."</p>
          <footer className="text-sm text-ink-muted mt-2">— Her practice philosophy</footer>
        </blockquote>
        <div className="mt-6 flex flex-wrap gap-2">
          {VALUES.map((v) => <span key={v} className="rounded-full bg-mint text-teal px-3 py-1 text-xs font-semibold">{v}</span>)}
        </div>
        <div className="mt-8 grid sm:grid-cols-2 gap-3">
          <div className="rounded-2xl bg-white border border-slate-200 p-4 flex gap-3"><Accessibility className="h-5 w-5 text-teal shrink-0" /><p className="text-sm"><strong className="block text-ink">Wheelchair-friendly</strong><span className="text-ink-muted">Accessible clinic environment</span></p></div>
          <div className="rounded-2xl bg-white border border-slate-200 p-4 flex gap-3"><ShieldCheck className="h-5 w-5 text-teal shrink-0" /><p className="text-sm"><strong className="block text-ink">Strict sterilisation</strong><span className="text-ink-muted">Hygiene protocols for every patient</span></p></div>
        </div>
        <figure className="mt-4 relative rounded-3xl overflow-hidden" data-testid="clinic-photo">
          <img src="/images/clinic-chair.jpg" alt="Treatment room at Smileton Dental, Sainikpuri" className="w-full aspect-[16/8] object-cover" />
          <figcaption className="absolute bottom-3 left-3 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-medium text-teal">Inside our Sainikpuri treatment room</figcaption>
        </figure>
      </div>
    </div>
  </section>
);
